<template>
  <div class="wrap-helper-show g-flex-column-sb">
    <div :style="{ height:bannerHeight+'px', background: `url(${imgPath}${topBanner}) no-repeat`}" class="banner" >
      <div v-if="isJoin" class="shop g-flex-c" @click="buy"><span>立即参与</span></div>
      <div v-else class="shop g-flex-c" @click="handleCheck"><span>查看已报名</span></div>
      <div class="shopOil g-flex-c"><img :src="imgPath+'fire.png'" alt="">{{count || 0}}座油站累计参加</div>
    </div>
    <div class="left-word" v-for="(item,index) in caseInfo[page]" :key="index">
      <template v-if="item.isImgLeft">
        <div class="con-wrap g-flex-c">
          <img :src="imgPath+item.img" alt="">
          <div>
            <div>{{item.title}}</div>
            <div class="word">{{item.info}}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="[item.img === 'traffic.png' ? 'special-con-wrap' : 'con-wrap', 'g-flex-c']">
          <div>
            <div class="left-show">{{item.title}}</div>
            <div class="word left-show">{{item.info}}</div>
          </div>
          <img :src="imgPath+item.img" alt="">
        </div>
      </template>
    </div>
    <Footer/>
    <agreement ref="agreement" :router="'/promotion/center'" :type="8"/>
  </div>
</template>
<script>
import { marketCenter, canJoin, checkGasSale, check } from '@/api/marketPromotion'
import agreement from './agreement'
import mixins from './mixin'
import Footer from './footer'
export default {
  mixins: [mixins],
  components: {
    Footer,
    agreement
  },
  data() { 
    return {
      isJoin: null, // 是否参与 1是可以参加，0不可以参加
      count: '', // 参与商家数
      bannerHeight: 400,
      page:'care',
      imgPath: 'https://web.nlktj.com/ty/merchant-h5/',
      topBanner: 'banner.png',
      caseInfo:{
        care: [
          {
            img:'traffic.png',
            isImgLeft: false,
            title: '流量曝光',
            info:'展示活动专属标签，通过加油送好礼标签可以快速筛选到您的油站'
          },
          {
            img:'carMaster.png',
            isImgLeft: true,
            title: '车主端权益',
            info:'首单加油满100元后可免费兑换一箱水'
          },
          {
            img:'maybe.png',
            isImgLeft: false,
            title: '预估效果',
            info:'新客流量曝光预估提升50%+，新客订单预估提升25%+'
          }
        ]
      }
    } 
  },
  mounted () {
    this.$track.pageViewEvent('0', 1632832578)
    this.marketCenterApi()
  },
  methods: {
    buy() {
      this.$track.clickEvent('立即报名', 1632832579, { tysj_trade_type: 0 })
      this.canJoinApi()
    },
    // 流程
    handleProcess () {
      this.$router.push({ path: '/promotion/center' })
    },
    // 查看我的营销
    handleCheck () {
      this.$track.clickEvent('查看已报名', 1632832579, { tysj_trade_type: 0 })
      this.$router.push({ path: '/promotionAudit/myPromotion' })
    },
    setSize () {
      // 通过浏览器宽度(图片宽度)计算高度
      if(this.screenWidth < 1080) return
      this.bannerHeight = 400 / 1920 * this.screenWidth;
    },
    async marketCenterApi () {
      try {
        const { code, result: { dtoList } } = await marketCenter({ activityTypes: '8' })
        if (code !== 200) return
        this.count = dtoList[0].joinedGasCount
        this.isJoin = dtoList[0].status// 1参加过， 0没有参加过
      } catch (error) {
        console.log(error)
      }
    },
    async canJoinApi () {
      try {
        const resGasSale = await checkGasSale()
        if (!resGasSale.result) {
          return this.$message.info('未查询到人站关系，继续报名会失败，请联系您的客户经理')
        }
        const { result } = await canJoin({ activityType: 8 })
        if(!result) {
          return this.$message.info('您已经参与过')
        }
        const resSigned = await check({ activityType: 8 }) // 7-天天特价 8-加油送水 9-限时秒杀
        if(resSigned.result.signed) {
          this.$router.push({ path: '/promotion/center'})
        } else {
          this.$refs.agreement.init(resSigned.result.title, resSigned.result.content)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap-helper-show{
  width: 100%;
  padding: 10px 0;
  background: #F8F9FD;
}
.banner{
  width: 100%;
  position: relative;
  background-size: 100%!important;
  margin-bottom: 10px;
  .shop{
    position: absolute;
    width: 192px;
    top: 60%;
    left: 5%;
    height: 48px;
    background: #E73934;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    >img{
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .shopOil{
    position: absolute;
    top: 85%;
    left: 5%;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #B1411C;
    >img{
      display: block;
      width: 12px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
.left-word{
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: #fff;
  margin: 10px 0;
  .special-con-wrap {
    width: 92%;
    height: 340px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    >div{
      width: 400px;
      margin: 0 20px;
    }
    >img{
      display: block;
      width: 640px;
      height: 183px;
      margin: 0 20px;
    }
    .word{
      font-size: 16px;
      line-height: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .left-show{
      text-align: right;
    }
  }
  .con-wrap {
    width: 80%;
    height: 340px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    >div{
      width: 360px;
      margin: 0 20px;
    }
    >img{
      display: block;
      width: 400px;
      height: 181px;
      margin: 0 20px;
    }
    .word{
      font-size: 16px;
      line-height: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .left-show{
      text-align: right;
    }
  }
}
.agreement{
  display: flex;
  flex-direction: column;
  align-items: center;
  .agree-tip{
    margin: 10px 0;
  }
  .doc{
    height: 500px;
    overflow-y: auto;
    padding: 10px 20px 20px 20px;
    text-indent: 28px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }
  .rule{
    margin: 18px 0;
    color: #666666;
    text-align: center;
  }
  .confirm {
    width: 100px;
    height: 40px;
    background: #4B7EFE;
    border-radius: 4px;
  }
}
/deep/.el-dialog__title{
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
}
</style>